module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "switch-container"
  }, [(_vm.title) ? _c('span', [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), _c('input', {
    class: _vm.switchClasses,
    attrs: {
      "type": _vm.type,
      "name": _vm.name,
      "disabled": _vm.disabled
    },
    domProps: {
      "checked": _vm.status,
      "value": _vm.value
    },
    on: {
      "change": _vm._change
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27e52a20"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/switch/switch-btn.vue
// module id = 676
// module chunks = 85